export default "__VITE_ASSET__DoYB9ZPD__"